// extracted by mini-css-extract-plugin
module.exports = {"pagination":"GDz7","item":"GDat","active":"GDs3","prevNextWrapper":"GDz9","next":"GDz-","arrow":"GDqn","disabled":"GDib","leftArrow":"GDaab"};